let currentDate = new Date()
$(function(){
    $('#medicalCenter').selectpicker();

    $('#vsCalendar').responsiveCalendar({
        monthChangeAnimation: true,
        translateMonths: [Lang.get('messages.january'),Lang.get('messages.february'),Lang.get('messages.march'),Lang.get('messages.april'),Lang.get('messages.may'),Lang.get('messages.june'),Lang.get('messages.july'),Lang.get('messages.august'),Lang.get('messages.september'),Lang.get('messages.october'),Lang.get('messages.november'),Lang.get('messages.december')],
        onDayClick: function(event) {
            let date = $(this).data('year')+'-'+addLeadingZero( $(this).data('month') )+'-'+addLeadingZero( $(this).data('day') );
            currentDate = new Date(date);
            bindHours();
        },
        onInit: function() {
            bindReservations();
            bindCalendar(this.currentMonth + 1, this.currentYear);
            bindHours();
        },
        onMonthChange: function() {
            bindCalendar(this.currentMonth + 1, this.currentYear);
        }
    });

    $('#medicalCenter').change(function(){
        var today = new Date();
        var month = today.getMonth() + 1;

        $('#vsCalendar').responsiveCalendar(today.getFullYear()+ '-' + ('0' + month).slice(-2));

        bindCalendar(month, today.getFullYear());
        bindHours();
    });

    $('.responsive-calendar').find('.day-selector').click(function(e){
        e.preventDefault();
        let plus = ($(this).data('go') === 'next') ? 1 : -1;
        currentDate.addDays(plus);
        bindHours();
    });

    $(document).on("submit", '#reservationForm', function(e){
        e.preventDefault();

        let data = $(e.target).serializeArray();
        let submitBtn = $(this).find('button[type="submit"]').first();

        submitBtn.prop('disabled', true);

        $.post( "/ajax/reservations/store", data, function(json) {
            if(json.success === true){
                Swal.fire(
                    Lang.get('messages.very_good'),
                    Lang.get('messages.reservation_success_message'),
                    'success'
                );
            }else{
                Swal.fire(
                    Lang.get('messages.ops'),
                    Lang.get('messages.reservation_request_failed_message'),
                    'info'
                );
            }
            bindHours();
            bindCalendar(currentDate.getMonth() + 1, currentDate.getFullYear());
            bindReservations();
            submitBtn.removeAttr('disabled');
            $('#reservationsNewModal').modal('hide');
        }, 'json');
    });

    $(document).on("submit", '#reservationRequestForm', function(e){
        e.preventDefault();

        let data = $(e.target).serializeArray();
        let submitBtn = $(this).find('button[type="submit"]');

        submitBtn.prop('disabled', true);

        $.post( "/ajax/reservations/request", data, function(json) {
            if(json.success === true){
                bindReservations();
                $('#reservationsRequestModal').modal('hide');
                Swal.fire(
                    Lang.get('messages.very_good'),
                    Lang.get('messages.reservation_request_success_message'),
                    'success'
                );
            }
            submitBtn.prop('disabled', false);
        }, 'json');
    });

    $(document).on("click", '.btn-group-hours > a[data-status="free"]', function(e){
        let day = $(this).data('dia');
        let hour = $(this).data('hora');
        let medical_center = $('#medicalCenter').val();

        e.preventDefault();
        $.post( "/ajax/reservations/employees", {date: day, hour: hour, medical_center: medical_center, type: 'new' }, function(json) {
            $('#reservationsNewModal').find('.modal-body').html(json.view);
            $('#reservationsNewModal').find('.selectpicker').selectpicker();
            $('#reservationsNewModal').modal('show');
        }, 'json');
    });

    $(document).on("click", '#reservations .request', function(e){
        let day = currentDate.toISOString().split('T')[0];
        let medical_center = $('#medicalCenter').val();

        e.preventDefault();
        $.post( "/ajax/reservations/employees", {date: day, medical_center: medical_center, type: 'request' }, function(json) {
            $('#reservationsRequestModal').find('.modal-body').html(json.view);
            $('#reservationsRequestModal').find('.selectpicker').selectpicker();
            $('#reservationsRequestModal .input-daterange').datepicker({
                format:'dd/mm/yyyy',
                startView: 0,
                maxViewMode: 2,
                autoclose: true,
                language: "es",
                orientation: "auto auto",
                startDate: '+1d'
            });
            $('#reservationsRequestModal').modal('show');
        }, 'json');
    });

    $(document).on("click", '#reservationList a.cancel', function(e){
        let id_reserva = $(this).data('reserva');
        let id_pendent = $(this).data('pendent');
        let id_exp = $(this).data('exp');

        e.preventDefault();

        Swal.fire({
            input: 'textarea',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'No',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            title: Lang.get('messages.cancel_title_confirm'),
            confirmButtonText: Lang.get('messages.confirm_button_text'),
            inputLabel: Lang.get('messages.cancel_text_confirm'),
            inputPlaceholder: Lang.get('messages.type_here_your_reason'),
            inputAttributes: {
                'aria-label': Lang.get('messages.cancel_text_confirm'),
                'required' : 'required'
            },
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value.length > 0) {
                        resolve()
                    } else {
                        resolve(Lang.get('messages.text_message_is_required'))
                    }
                })
            }
        }).then((result) => {
            if (result.isConfirmed) {
                $.post( "/ajax/reservations/cancel", {'id_reserva': id_reserva, 'id_pendent': id_pendent, 'id_exp': id_exp, text: result.value }, function(json) {
                    if(json.success === true){
                        bindCalendar(currentDate.getMonth() + 1, currentDate.getFullYear());
                        bindReservations();
                        bindHours();
                        Swal.fire(
                            Lang.get('messages.very_good'),
                            Lang.get('messages.reservation_cancel_success_message'),
                            'success'
                        )
                    }else{
                        let message = (!!json.message && json.message.length > 0) ? json.message : Lang.get('messages.ops_message');
                        Swal.fire(
                            Lang.get('messages.ops'),
                            message,
                            'danger'
                        )
                    }
                }, 'json');
            }
        })
    })
});

function bindCalendar(month, year){
    let medical_center = $('#medicalCenter').val();
    $.post( "/ajax/reservations/days", { month: month, year: year, medical_center: medical_center }, function(json) {
        if(json.success === true){
            $('#vsCalendar').responsiveCalendar('clearAll')
            let params = {};
            $.each(json.days, function(key, data){
                params[data['dia']] = {"number": data['num_intervals'], "badgeClass": "badge-warning"};
            });
            $('#vsCalendar').responsiveCalendar('edit', params);

            //Per arreglar bug bordes doblats
            window.setTimeout(function(){
                $('#vsCalendar').find('.day').css('border', '1px solid #ededed');
            }, 1000)
        }
    }, 'json');
}

function bindHours(){
    let myDate = currentDate.toISOString().split('T')[0];
    let medical_center = $('#medicalCenter').val();
    let container = $('.responsive-calendar').find('.hours');
    let group = $('<div class="btn-group btn-group-hours d-flex" style="margin-bottom: 2px" role="group" aria-label="Justified button group"></div>');

    $.post("/ajax/reservations/hours", {date: myDate, medical_center: medical_center}, function (json) {
        let num = 0;

        $('.responsive-calendar').find('h4 span.data-day').html(json.day_name);
        $('.responsive-calendar').find('h4 span.data-date').html(json.myDate);

        container.empty();

        //Afegeixo el llistat d'hores
        if (Object.keys(json.hours).length) {
            $.each(json.hours, function (hour, status) {
                let className = (status === 'free') ? 'success' : 'danger';
                group.append('<a href="#" role="button" data-hora="' + hour + '" data-status="' + status + '" data-dia="' + json.date + '" class="btn btn-' + className + ' w-100">' + hour + '</a>\n')
                num++;
                if (num === 3) {
                    container.append(group.clone());
                    group.empty();
                    num = 0;
                }
            });
            container.append(group);
        } else {
            if(currentDate < new Date()) {
                container.append('<p class="text-center">'+Lang.get('messages.vs_reservations_msg1')+'</p>');
            }else{
                container.append('<p class="text-center">'+Lang.get('messages.vs_reservations_msg2')+'</p>');
            }
        }

        //Si el centre és diferent de l'1 (Pvcat Edifici Punt Blau) mostrar el botó per afegir a pendents de convocar.
        if(medical_center !== '1'){
            container.append('<p class="small text-muted mt-1 mb-0">'+Lang.get('messages.availability_message')+'</p>');
            if(medical_center === '34'){
                container.append('<p class="small text-muted mt-1">'+Lang.get('messages.mobile_unit_text')+'</p>');
            }
            container.append('<div class="text-center mt-2"><button type="buttom" class="btn btn-primary btn-sm request">'+Lang.get('messages.make_request')+'</button></div>');
        }
    }, 'json');
}

function bindReservations(){
    let list = $('#reservationList');
    let has_print_btn = false;

    $.post("/ajax/reservations/all", function (json) {
        list.empty();
        if(Object.keys(json.reservations).length){
            $.each(json.reservations, function(key, value){
                let time = (value.id_pen === null) ? (value.data + ' ' + value.hora) : '<i class="fs-12">'+value.data+'</i>';
                let title = '';
                let bg_color;

                if(value.id_exp !== null){
                    title = Lang.get('messages.confirmed');
                    bg_color = 'green';
                    has_print_btn = true;
                }else if(value.id_pen !== null){
                    bg_color = 'orange';
                    title = Lang.get('messages.pending_confirmation');
                }else if(value.id !== null){
                    bg_color = 'primary'
                    has_print_btn = true;
                }

                let topic = $(
                    '<div class="topic bordered">\n' +
                    '    <span class="topic-label bg-'+bg_color+'" data-toggle="tooltip" data-placement="top" title="'+title+'"></span>\n' +
                    '    <div class="row align-items-center">\n' +
                    '          <div class="col-md-4">\n' +
                    '                <h4 class="topic-title">'+value.nom_treballador+'</h4>\n' +
                    '          </div>\n' +
                    '          <div class="col-md-4">\n' +
                    '                <span class="small text-muted">'+value.nom_centre+'</span>\n' +
                    '          </div>\n' +
                    '          <div class="col-md-2">\n' +
                    '                <time class="small text-muted">'+time+'</time>\n' +
                    '          </div>\n' +
                    '    </div>\n' +
                    '</div>\n');


                topic.find('.row')
                    .append('<div class="col-md-2 text-right">\n' +
                        '       <a href="#" class="d-inline cancel" data-exp="'+value.id_exp+'" data-pendent="'+value.id_pen+'" data-reserva="'+value.id+'">'+Lang.get('messages.cancel')+'</a>\n' +
                        '    </div>\n');

                list.append(topic);
            });

            //Bind toolstips
            list.find('[data-toggle="tooltip"]').tooltip();

            //Print button
            if(has_print_btn) {
                list.append('' +
                    '<p class="mt-3">\n' +
                    '   <a href="/reservations/print" class="btn btn-sm btn-primary rounded">\n' +
                    '       <i class="icon-file-pdf-o mr-1"></i>' + Lang.get('messages.print_reservation_list') + '\n' +
                    '   </a>\n' +
                    '</p>');
            }
        }else{
            list.html('' +
                '<div class="alert alert-warning" role="alert">\n' +
                '    <h4>'+Lang.get('messages.attention')+'!</h4>\n' +
                '    <p>'+Lang.get('messages.reservation_no_data')+'</p>\n' +
                '    <i class="icon-alert-circle"></i>\n' +
                '</div>');
        }
    }, 'json');
}

Date.prototype.addDays = function(days){
    days = parseInt(days, 10)
    this.setDate(this.getUTCDate() + days);
    return this;
}

function addLeadingZero(num) {
    if (num < 10) {
        return "0" + num;
    } else {
        return "" + num;
    }
}
